import { MyProfileAvatar } from '@/components/my-profile-avatar.tsx';
import { TodayMetricsBESS } from '@/features/bess/components/bess-metrics.tsx';
import { BessChargeDischargePowerChart } from '@/features/bess/components/bess-charge-discharge-power-chart.tsx';
import { BessStateOfChargeChart } from '@/features/bess/components/bess-state-of-charge-chart.tsx';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb.tsx';
import { Link, Navigate, useParams } from 'react-router';
import { useMediaQuery } from '@/hooks/use-media-query.tsx';
import { useGetBESSQuery } from '@/features/bess/hooks/queries/[bess]/get-bess.ts';
import { Skeleton } from '@/components/ui/skeleton.tsx';

const BESSPage = () => {
  const { bessId } = useParams();
  const isMobile = useMediaQuery('(max-width:640px)');

  const { data, isLoading } = useGetBESSQuery({ id: bessId });

  if (isMobile) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className="overview w-full gap-2 overflow-auto px-4 pt-3 pb-8 sm:px-6">
      <div className="flex flex-col gap-6">
        <div className="flex h-[45px] items-center justify-between gap-4">
          {!isMobile && (
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem className="link-underline">
                  <BreadcrumbLink asChild>
                    <Link to="/dashboard">Dashboard</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem className="">
                  <BreadcrumbLink>
                    <span>BESS</span>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage className="flex items-center gap-1 font-semibold">
                    <span>{data?.name} overview</span>
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          )}

          <div className="flex gap-2">
            <MyProfileAvatar />
          </div>
        </div>
        <div className="flex flex-col gap-4">
          {isLoading ? (
            <Skeleton className="h-9 w-32" />
          ) : (
            <div className="flex min-h-9 w-full justify-between">
              <h2 className="text-2xl font-semibold">{data?.name}</h2>
            </div>
          )}
          <TodayMetricsBESS />
          <div className="@container">
            <div className="grid gap-6 @min-[800px]:grid-cols-5">
              <BessChargeDischargePowerChart className="@min-[800px]:col-span-3" />
              <BessStateOfChargeChart className="@min-[800px]:col-span-2" />
            </div>
          </div>
          {/*<div className="@container">*/}
          {/*  <div className="grid gap-6 @min-[800px]:grid-cols-5">*/}
          {/*    <BessSystemAlerts className="@min-[800px]:col-span-2" />*/}
          {/*    <BessCellPerformanceAndControl className="@min-[800px]:col-span-3" />*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
      </div>
    </div>
  );
};

export default BESSPage;
